// extracted by css-extract-rspack-plugin
export default {"cls1":"PremiumUpsellPopover-cls1_44a","cls2":"PremiumUpsellPopover-cls2_vee PremiumUpsellPopover-cls1_44a"};